export default "__VITE_ASSET__Dm7ZAd73__"